import React from 'react'
import {RouterProvider} from "react-router-dom"
import {router} from "./routes"
import {Spin} from "antd"

function App() {
  return (
    <RouterProvider
      router={router}
      fallbackElement={<Spin tip="Loading..."/>}
    />
  )
}

export default App